import { render, staticRenderFns } from "./Package2Card.vue?vue&type=template&id=6bf4b634&scoped=true"
import script from "./Package2Card.vue?vue&type=script&lang=ts"
export * from "./Package2Card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf4b634",
  null
  
)

export default component.exports